import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { CloudinaryImage } from "@website-builder/ui/shared/elements";
import { SelectWrapper, CheckBox, Option } from "./styles";

const Select = (props) => {
	const {
		options = [],
		value,
		onChange = () => {},
		head = { label: "", iconUrl: "" },
		multiple = true,
		clear,
		showOptions = false,
	} = props;
	const [showAllOptions, setShowAllOptions] = useState(showOptions);
	const [items, setItems] = useState(options);
	const [selectedCheckboxes, setSelected] = useState({});

	const handleChange = (e) => {
		let updateSelected = { ...selectedCheckboxes };
		if (selectedCheckboxes[e]) {
			delete updateSelected[e];
			setSelected(updateSelected);
		} else {
			updateSelected[e] = true;
			setSelected(updateSelected);
		}

		//Fire OnChange
		onChange(Object.keys(updateSelected));
	};
	useEffect(() => {
		setSelected({});
		setShowAllOptions(false);
	}, [clear]);
	useEffect(() => {
		setShowAllOptions(false);
	}, [showOptions]);

	return (
		<SelectWrapper showAllOptions={showAllOptions}>
			<Option
				className="option-title"
				onClick={() => setShowAllOptions(!showAllOptions)}
				showAllOptions={showAllOptions}
			>
				{head.iconUrl && (
					<CloudinaryImage
						className="optionIcon"
						lazyload
						url={head.iconUrl}
						sizes={{ default: { width: 22 } }}
					/>
				)}
				<div className="optionLabel">{head.label}</div>
				<div className="caretIcon">
					<CloudinaryImage
						sizes={{ default: { height: 10 } }}
						lazyload
						url="https://res.cloudinary.com/springboard-images/image/upload/v1592665526/homepage-assets/navigation-bar/down-arrow.svg"
					/>
				</div>
			</Option>
			{multiple && showAllOptions && (
				<div className="allOptions">
					{items
						.filter((o) => o.value !== value)
						.map((o, index) => (
							<Option
								onClick={(e) => {
									e.preventDefault();
									handleChange(o);
								}}
								key={o.value}
								isSelected={!!selectedCheckboxes[o]}
							>
								<CheckBox>
									<label class="container">
										{o}
										<input
											value={selectedCheckboxes[o]}
											type="checkbox"
											checked={!!selectedCheckboxes[o]}
										/>
										<span class="checkmark"></span>
									</label>
								</CheckBox>
							</Option>
						))}
				</div>
			)}
		</SelectWrapper>
	);
};

Select.propTypes = {
	options: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.string,
			label: PropTypes.string,
			iconUrl: PropTypes.string,
		}),
	),
	value: PropTypes.string,
	onChange: PropTypes.func,
};

Select.defaultProps = {
	options: [],
	value: "",
	onChange: () => {},
};
export default Select;
